/**
 * Clase para configurar a donde se debe conectar.
 */
class Config {  
    static DOMAIN_API = 'https://api.inces.net.ve/';
    static API_URL = `${this.DOMAIN_API}apirest/`;
}

export default Config;
